import { createContext } from 'react'

/** @type React.Context<{ auth: firebase.User | undefined, user: SM.User | undefined }> */
const AuthContext = createContext({
  auth: undefined,
  user: undefined,
})

export default AuthContext
